import { useMutation } from '@apollo/client';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import DefaultModal from 'components/common/DefaultModal';
import { INPUT_TYPE } from 'components/common/Input/types';
import InputFieldsGenerator from 'components/InputFieldsGenerator';
import { InputProps } from 'components/InputFieldsGenerator/types';
import { Form, Formik } from 'formik';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { useDispatch } from 'react-redux';
import { AuthAction } from 'redux/actions';
import { CancelButtonStyled } from 'routes/Users/components/CreateUserModal/styled';
import { UPDATE_USER } from 'services/graphql/mutations/users';
import { GeneralFunction } from 'types/common';
import { defaultNotification } from 'utils';
import * as Yup from 'yup';

const { userSignOut } = AuthAction;

const changePasswordSchema = Yup.object({
  oldPassword: Yup.string().required('Required'),
  password: Yup.string().required('Required'),
  // .notOneOf([Yup.ref('oldPassword')], "Can't use old password."),
  retypePassword: Yup.string()
    .min(6)
    .required('Required')
    .oneOf([Yup.ref('password')], 'Password mismatch'),
});
const ChangePasswordModal: React.FC<{ visible: boolean; onCancel: GeneralFunction }> = ({ visible, onCancel }) => {
  const [updateUser, { loading }] = useMutation(UPDATE_USER);
  const userId = useCurrentLoggedInUser().id;
  const dispatch = useDispatch();
  const resetPasswordFormInputs: InputProps[] = [
    {
      name: 'oldPassword',
      label: 'Current password',
      type: INPUT_TYPE.PASSWORD,
    },
    {
      name: 'password',
      label: 'New password',
      type: INPUT_TYPE.PASSWORD,
    },
    { name: 'retypePassword', label: 'Retype new password', type: INPUT_TYPE.PASSWORD },
  ];

  const onSubmit = async (inputValue: { password: string }) => {
    try {
      await updateUser({
        variables: {
          filter: {
            id: userId,
          },
          updatedDoc: {
            password: inputValue.password,
          },
        },
      });
      dispatch(userSignOut());
      defaultNotification({ success: 'Change password successfully! Please login again.' });
    } catch (err) {
      defaultNotification({ failure: 'Change password failed! Please try again.' });
    }
  };

  return (
    <>
      <DefaultModal props={{ visible, onCancel, title: 'Change Password', destroyOnClose: true }}>
        <Formik
          initialValues={{ oldPassword: '', password: '', retypePassword: '' }}
          name='basic'
          onSubmit={onSubmit}
          validationSchema={changePasswordSchema}
          enableReinitialize
          validateOnBlur>
          <Form className=''>
            <InputFieldsGenerator formFields={resetPasswordFormInputs} />
            <ButtonWithSpinner isLoading={loading} className='gx-mb-0 gx-mt-2' htmlType='submit'>
              Change
            </ButtonWithSpinner>
            <CancelButtonStyled className='gx-mb-0 gx-mt-2' onClick={onCancel}>
              Cancel
            </CancelButtonStyled>
          </Form>
        </Formik>
      </DefaultModal>
    </>
  );
};

export default ChangePasswordModal;
